(() => {
  // The script tag is rendered once per video slide - run only once.
  if (window.ykHeroVideoInitialized) return;
  window.ykHeroVideoInitialized = true;

  // Keep the poster image only for users who opted out of motion or data usage.
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection?.saveData === true;
  if (reducedMotion || saveData) return;

  const setupVideo = (video) => {
    const mobileQuery = window.matchMedia(video.dataset.mobileQuery);
    let isVisible = false;

    const getSource = () => (mobileQuery.matches ? video.dataset.srcMobile : video.dataset.srcDesktop);

    const play = () => {
      const promise = video.play();
      if (promise) promise.catch(() => {});
    };

    // Poster stays visible until the video actually starts playing.
    const loadSource = () => {
      const src = getSource();
      if (!src || video.getAttribute('src') === src) return;

      video.style.opacity = '0';
      video.src = src;
      video.load();
    };

    video.muted = true;
    video.addEventListener('playing', () => {
      video.style.opacity = '1';
    });

    // Load lazily when the slide is visible, pause when it is swiped away.
    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;

        if (isVisible) {
          loadSource();
          play();
        } else if (!video.paused) {
          video.pause();
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(video);

    // Crossing the breakpoint swaps to the matching file.
    mobileQuery.addEventListener('change', () => {
      if (!video.getAttribute('src')) return;

      loadSource();
      if (isVisible) play();
    });
  };

  const init = () => document.querySelectorAll('video[data-yk-hero-video]').forEach(setupVideo);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
